import { Currency } from "src/types";

export const getCurrencySign = (currency: Currency): string => {
    const currencyMap: Record<string, string> = {
        dollar: "$",
        naira: "₦",
        pound: "£",
        euro: "€"
    };

    return currencyMap[currency] || "₦"; // Default to Naira
};


